import {DocumentIdAttr, DocumentTypeEnum} from "../api/values/document-type";

/**
 * ドキュメント種別を判定し、id属性に付与する文字列を返す。
 *
 * @param documentType ドキュメントタイプ（ARTICLE, PERSON, BLOCKなど）
 * @param templateId テンプレートID（BLOCKの場合のみ使用）
 * @returns id属性用のドキュメント種別（is-article, is-block, is-format-block）
 */
export function getDocumentIdAttr(
    documentType: DocumentTypeEnum,
    templateId?: string,
    isDeletedTemplate?: boolean,
): DocumentIdAttr {
    switch (documentType) {
        case DocumentTypeEnum.ARTICLE:
        case DocumentTypeEnum.PERSON:
            return DocumentIdAttr.ARTICLE;
        case DocumentTypeEnum.BLOCK:
            return templateId && !isDeletedTemplate
                ? DocumentIdAttr.FORMAT_BLOCK
                : DocumentIdAttr.BLOCK;
    }
}
